/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfigurationResponse } from '../../models/configuration-response';
import { UpdateConfigurationRequest } from '../../models/update-configuration-request';

export interface UpdateOptsConfigurations$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
      body: UpdateConfigurationRequest
}

export function updateOptsConfigurations(http: HttpClient, rootUrl: string, params: UpdateOptsConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfigurationResponse>> {
  const rb = new RequestBuilder(rootUrl, updateOptsConfigurations.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConfigurationResponse>;
    })
  );
}

updateOptsConfigurations.PATH = '/stores/{storeId}/preptimes';
